import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, ErrorHandler, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router } from '@angular/router';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';

import * as Sentry from "@sentry/angular";

import { routes } from './app.routes';

import { authInterceptor } from 'anatoliapps-angular/auth';
import { i18nInterceptor } from 'hakikat/interceptors';

import { SettingsService } from 'hakikat/services';
import { FIREBASE_CONFIG } from 'hakikat/utils';

import { AuthService } from './core/auth/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      return inject(AuthService).initialize();
    }),

    // Angular
    provideHttpClient(withInterceptors([authInterceptor, i18nInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    // Firebase
    provideFirebaseApp(() => initializeApp(FIREBASE_CONFIG)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),

    // Firebase Analytics Services
    ScreenTrackingService,
    UserTrackingService,

    // Application Initializer Services
    {
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: (settings: SettingsService) => {
        return settings.localization.currency 
        // || DEFAULT_CURRENCIES[inject(LOCALE_ID) as Locale]
        || 'EUR';
      },
      deps: [SettingsService]
    },
    // {
    //   provide: ErrorHandler,
    //   useFactory: (loggerService: LoggerService) => {
    //     return new (class implements ErrorHandler {
    //       handleError(error: Error): void {
    //         loggerService.log(error);
    //       }
    //     })();
    //   },
    //   deps: [LoggerService]
    // },

    // Sentry Services
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    }
  ],
};
